import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { toast } from 'sonner';
import { Dialog } from '@/ui/Dialog';
import { Field } from '@/ui/Field';
import { api } from '@/lib/api';

const schema = z.object({
  oldPassword: z.string().min(1, 'Mevcut şifreyi giriniz'),
  newPassword: z.string().min(1, 'Yeni şifre giriniz').max(64),
  newPassword2: z.string(),
}).refine((v) => v.newPassword === v.newPassword2, { path: ['newPassword2'], message: 'Girmiş Olduğunuz Yeni Şifre Tutarsız..!' });

/** Delphi Unit62 (Şifre Değiştirme) */
export function ChangePasswordDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (o: boolean) => void }) {
  const { register, handleSubmit, formState, reset } = useForm<z.infer<typeof schema>>({ resolver: zodResolver(schema) });
  const submit = async (v: z.infer<typeof schema>) => {
    try {
      const r = await api('/auth/change-password', { body: v });
      toast.success(r.message);
      reset();
      onOpenChange(false);
    } catch (e: any) {
      toast.error(e.message);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange} title="Şifre Değiştirme" className="w-[min(400px,92vw)]"
      footer={<><button className="btn" onClick={() => onOpenChange(false)}>Vazgeç</button><button className="btn btn-primary" onClick={handleSubmit(submit)}>Değiştir</button></>}>
      <form className="flex flex-col gap-3" onSubmit={handleSubmit(submit)}>
        <Field label="Mevcut Şifre" error={formState.errors.oldPassword?.message}><input type="password" className="inp" {...register('oldPassword')} /></Field>
        <Field label="Yeni Şifre" error={formState.errors.newPassword?.message}><input type="password" className="inp" {...register('newPassword')} /></Field>
        <Field label="Yeni Şifre (Tekrar)" error={formState.errors.newPassword2?.message}><input type="password" className="inp" {...register('newPassword2')} /></Field>
        <button type="submit" className="hidden" />
      </form>
    </Dialog>
  );
}
